import { baseUrl } from "./config";

export const basicAPIRequest = (path, body) => {
  return fetch(`${baseUrl}${path}`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(body)
  })
    .then(res => {
      return res.json();
    })
    .catch(err => {
      throw err;
    });
};

export const authAPIRequest = (path, body, token) => {
  return fetch(`${baseUrl}${path}`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(body)
  })
    .then(res => {
      return res.json();
    })
    .catch(err => {
      throw err;
    });
};